frontApp.share = {
  name: 'share',
  description: 'share',
  isOpen: false,
  init() {
    const btns = document.querySelectorAll('.js-share-btn');
    if (!btns.length) {
      return false;
    }

    btns.forEach((btn) => {
      btn.addEventListener('click', (evt) => {
        evt.preventDefault();
        const container = btn.closest('.js-share');
        const drop = container.querySelector('.js-share-drop');
        if (this.isOpen) {
          this.close([btn, container, drop]);
        } else {
          this.open([btn, container, drop]);
        }
      });
    });

    document.addEventListener('click', (evt) => {
      if (
        !evt.target.closest('.js-share-btn')
        && !evt.target.closest('.js-share')
      ) {
        this.close();
      }
    });

    document.addEventListener('keydown', (evt) => {
      if (evt.key === 'Escape' && this.isOpen) {
        this.close();
      }
    });
  },
  open(els) {
    this.isOpen = true;
    if (!els || !els.length) {
      const allEls = document.querySelectorAll('.js-share-btn, .js-share, .js-share-drop');
      allEls.forEach((el) => {
        el.classList.add('is-open');
      });
    } else {
      els.forEach((el) => el.classList.add('is-open'));
    }
  },
  close(els) {
    this.isOpen = false;
    if (!els || !els.length) {
      const allEls = document.querySelectorAll('.js-share-btn, .js-share, .js-share-drop');
      allEls.forEach((el) => {
        el.classList.remove('is-open');
      });
    } else {
      els.forEach((el) => el.classList.remove('is-open'));
    }
  },
};
